<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.4522 5H8.71934C6.43344 5 5 6.61856 5 8.90911V15.0909C5 17.3814 6.42644 19 8.71934 19H15.2791C17.5728 19 19 17.3814 19 15.0909V13.7368"
      stroke="#8F42FF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M19 8.2074V5M19 5H15.7926M19 5L12 12"
      stroke="#8F42FF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
